import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.ambientetrabalhor.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}

export const ActionDeletar = ({dispatch},payload)=>{
    return serves.ambientetrabalhor.delete(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.ambientetrabalhor.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.ambientetrabalhor.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.ambientetrabalhor.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEvento = ({dispatch},payload)=>{
    return serves.ambientetrabalhor.evento(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}

export const ActionEventoLista = ({dispatch},payload)=>{
    return serves.ambientetrabalhor.eventolista(payload).then(res => {
        dispatch('ActionSetListaEvento',res)
    }).catch(err => {
        dispatch('ActionSetListaEvento',err)
    })
}

export const ActionEventoCadastro = ({dispatch},payload)=>{
    return serves.ambientetrabalhor.eventocadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEventoUpdate = ({dispatch},payload)=>{
    return serves.ambientetrabalhor.eventoupdate(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEventoDelete = ({dispatch},payload)=>{
    return serves.ambientetrabalhor.eventodelete(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}

export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetListaEvento = ({commit},payload) =>{
    commit(types.SET_LISTAEVENTO,payload)
}